import {
  SET_LEFT_NAV_COLLECTION,
  SET_PRODUCT_VIEW_STYLE,
  SET_VISIBLE_COLLECTION_INFO,
  SET_PRODUCT_ADDED_INFO,
  SET_PRODUCT_ADDED_INFO_CLEAR,
} from './action';

const initialState = {
  leftNavCollection: [],
  productViewStyle: '',
  visibleCollection: {
    collectionId: null,
    viewportPercentage: 0,
  },
  productAddedInfo: [],
};

const catalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEFT_NAV_COLLECTION:
      return {
        ...state,
        leftNavCollection: action.payload,
      };
    case SET_PRODUCT_VIEW_STYLE:
      return {
        ...state,
        productViewStyle: action.payload,
      };
    case SET_VISIBLE_COLLECTION_INFO:
      return {
        ...state,
        visibleCollection: action.payload,
      };
    case SET_PRODUCT_ADDED_INFO: {
      let productAddedInfoTemp = [];
      const is_product_present = state?.productAddedInfo.some(
        (item) => item.id === action?.payload?.id
      );

      if (is_product_present) {
        productAddedInfoTemp = state?.productAddedInfo?.map((item) => {
          if (item?.id === action?.payload?.id) {
            return action?.payload;
          } else return item;
        });
      } else {
        productAddedInfoTemp = [
          ...(state?.productAddedInfo ?? []),
          action?.payload,
        ];
      }

      return {
        ...state,
        productAddedInfo: productAddedInfoTemp,
      };
    }
    case SET_PRODUCT_ADDED_INFO_CLEAR:
      return {
        ...state,
        productAddedInfo: [],
      };
    default:
      return state;
  }
};

export default catalogReducer;
